/**
 * Política de senha para CRIAR ou ALTERAR uma senha (cadastro, redefinição, troca de senha e
 * criação de usuário por administrador). Espelha o backend
 * (`domains/auth/domain/validators.py: password_meets_policy`):
 * mínimo de 8 caracteres, com letra maiúscula, letra minúscula, número e caractere especial.
 *
 * O login não usa esta política: quem já tem uma senha mais fraca continua entrando
 * normalmente e só precisa cumpri-la se decidir trocar a senha.
 */
export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordChecks {
  minLength: boolean;
  upper: boolean;
  lower: boolean;
  number: boolean;
  /** Qualquer símbolo que não seja letra, número ou espaço. */
  special: boolean;
}

export const checkPassword = (password: string): PasswordChecks => ({
  minLength: password.length >= PASSWORD_MIN_LENGTH,
  upper: /\p{Lu}/u.test(password),
  lower: /\p{Ll}/u.test(password),
  number: /\p{Nd}/u.test(password),
  special: /[^\p{L}\p{N}\s]/u.test(password),
});

export const isPasswordValid = (password: string): boolean =>
  Object.values(checkPassword(password)).every(Boolean);
